module.exports = __webpack_public_path__ + "static/media/swipe-down.d03b1500.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/swipe-down.svg
// module id = 302
// module chunks = 0